import React from "react";

export default function Copyright() {
  return (
    <div
      style={{
        position: "fixed",
        bottom: "70px",
        right: "4px",
        transform: "rotate(90deg) translateY(100%)",
        transformOrigin: "right bottom",
        whiteSpace: "nowrap",
        fontSize: "12px",
        color: "white",
        fontFamily: "monospace",
        zIndex: 100,
      }}
    >
      © {new Date().getFullYear()} RCCS
    </div>
  );
}
